import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { useHistory } from "react-router-dom";
import { Steps } from "antd";
import "./RegistrationForm.css";
import { handleRegistration } from "../services/services";
import ViewModal from "./Map/container/ViewModal";
import ModalContent from "./Map/container/ModalContent";
import { inputValidation } from "./Map/utils";

const RegistrationForm = () => {
  const history = useHistory();
  const [name, setName] = useState(null);
  const [surname, setSurname] = useState(null);
  const [email, setEmail] = useState(null);
  const [address, setAddress] = useState(null);
  const [password, setPassword] = useState(null);
  const [verifyPassword, setVerifyPassword] = useState(null);
  const [currentStep, setCurrentStep] = useState(0);
  const [showModal, setShowModal] = useState(false);
  const [modalType, setModalType] = useState(null);
  const [isButtonDisabled, setIsButtonDisabled] = useState(true);

  const [nameError, setNameError] = useState(null);
  const [surnameError, setSurnameError] = useState(null);
  const [addressError, setAddressError] = useState(null);
  const [emailError, setEmailError] = useState(null);
  const [passwordError, setPasswordError] = useState(null);
  const [verifyPasswordError, setVerifyPasswordError] = useState(null);

  const nextStep = () => setCurrentStep(currentStep + 1);
  const prevStep = () => setCurrentStep(currentStep - 1);

  const handleInput = (setter, value) =>
    setter(value.length === 0 ? null : value);

  useEffect(() => {
    handleButton();
  }, [
    name,
    surname,
    email,
    password,
    verifyPassword,
    address,
    currentStep,
    nameError,
    surnameError,
    addressError,
    emailError,
    passwordError,
    verifyPasswordError,
  ]);

  const steps = [
    {
      title: "Βήμα 1ο",
      subtitle: "Συμπλήρωση προσωπικών στοιχείων",
      content: (
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            gap: "10px",
          }}
        >
          <FormItem>
            <ItemTitle>Όνομα</ItemTitle>
            <ItemInput
              value={name ?? ""}
              onChange={(event) => {
                const nameValue = event.target.value;
                setNameError(inputValidation("name", nameValue, name));
                handleInput(setName, nameValue);
              }}
            />
            <ErrorText>{nameError}</ErrorText>
          </FormItem>
          <FormItem>
            <ItemTitle>Επώνυμο</ItemTitle>
            <ItemInput
              value={surname ?? ""}
              onChange={(event) => {
                const nameValue = event.target.value;
                setSurnameError(inputValidation("surname", nameValue, surname));
                handleInput(setSurname, nameValue);
              }}
            />
            <ErrorText>{surnameError}</ErrorText>
          </FormItem>
          <FormItem>
            <ItemTitle>Διεύθυνση</ItemTitle>
            <ItemInput
              value={address ?? ""}
              onChange={(event) => {
                const nameValue = event.target.value;
                setAddressError(inputValidation("address", nameValue, address));
                handleInput(setAddress, nameValue);
              }}
            />
            <ErrorText>{addressError}</ErrorText>
          </FormItem>
        </div>
      ),
    },
    {
      title: "Βήμα 2ο",
      subtitle: "Δημιουργία λογαρισμού",

      content: (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            flexDirection: "column",
            gap: "10px",
          }}
        >
          <FormItem>
            <ItemTitle>E-mail</ItemTitle>
            <ItemInput
              value={email ?? ""}
              onChange={(event) => {
                const nameValue = event.target.value;
                setEmailError(inputValidation("email", nameValue, email));

                handleInput(setEmail, nameValue);
              }}
            />
            <ErrorText>{emailError}</ErrorText>
          </FormItem>
          <FormItem>
            <ItemTitle>Κωδικός Πρόσβασης</ItemTitle>
            <ItemInput
              value={password ?? ""}
              onChange={(event) => {
                const nameValue = event.target.value;

                setPasswordError(
                  inputValidation("password", nameValue, password)
                );

                handleInput(setPassword, nameValue);
              }}
            />
            <ErrorText>{passwordError}</ErrorText>
          </FormItem>
          <FormItem>
            <ItemTitle>Επιβεβαίωση Κωδικού</ItemTitle>
            <ItemInput
              value={verifyPassword ?? ""}
              onChange={(event) => {
                const nameValue = event.target.value;

                setVerifyPasswordError(
                  inputValidation("verifyPassword", nameValue, password)
                );

                handleInput(setVerifyPassword, nameValue);
              }}
            />
            <ErrorText>{verifyPasswordError}</ErrorText>
          </FormItem>
        </div>
      ),
    },
  ];

  const items = steps.map((item) => ({
    key: item.title,
    title: "",
  }));

  const handleButton = () => {
    const checks = [
      [nameError, surnameError, addressError],
      [emailError, passwordError, verifyPasswordError],
    ];
    for (let check of checks[currentStep]) {
      if (check !== null) {
        setIsButtonDisabled(true);
        return;
      }
    }
    setIsButtonDisabled(false);
  };

  return (
    <Container>
      <ContentWrapper>
        <Logo />
        <Title>Εγγραφή</Title>
        <StepperForm
          responsive={false}
          current={currentStep}
          items={items}
          size="small"
          type="navigation"
        />
        <p
          style={{
            fontSize: "14px",
            color: "#4F82FC",
            margin: "0",
            padding: "0",
          }}
        >
          {steps[currentStep].title}
        </p>
        <p
          style={{
            fontSize: "18px",
            color: "#373B40",
            margin: "0",
            padding: "0",
            textAlign: "center",
          }}
        >
          {steps[currentStep].subtitle}
        </p>
        <div style={{ width: "100%" }}>{steps[currentStep].content}</div>
        <NavigationButtons style={{}}>
          {currentStep === steps.length - 1 && (
            <PrevButton onClick={() => prevStep()}>Πίσω</PrevButton>
          )}
          {currentStep !== steps.length - 1 && (
            <NextButton onClick={() => nextStep()} disabled={isButtonDisabled}>
              Επόμενο
            </NextButton>
          )}
          {currentStep === steps.length - 1 && (
            <RegisterButton
              disabled={isButtonDisabled}
              onClick={() =>
                handleRegistration({
                  firstName: name,
                  lastName: surname,
                  email: email,
                  password,
                  address,
                }).then((response) => {
                  if (response !== null) {
                    console.log("Registration Successful!");
                    setModalType(response ? "success" : "failure");
                    setShowModal(true);
                  } else {
                    console.log("Registration Failed!");
                  }
                })
              }
            >
              Εγγραφή
            </RegisterButton>
          )}
        </NavigationButtons>
      </ContentWrapper>
      <ViewModal
        modalStatus={showModal}
        //   title="Επιλογή Σημείου"
        closeModal={() =>
          modalType === "success" ? history.push("/") : setShowModal(false)
        }
      >
        <ModalContent
          content={{
            type: "response",
            status: modalType,
            version: "user",
          }}
        />
      </ViewModal>
    </Container>
  );
};

export default RegistrationForm;

const Container = styled.div`
  width: 550px;
  height: fit-content;
  background: #ffffffee;
  position: absolute;
  top: calc((100% - 500px) / 2);
  left: calc((100% - 550px) / 2);
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: flex-start;

  border-radius: 10px;
  box-shadow: 0 0 4px #373b4029;

  @media only screen and (max-width: 808px) {
    width: 400px;
    left: calc((100% - 400px) / 2);
  }

  @media only screen and (max-width: 448px) {
    width: 340px;
    left: calc((100% - 340px) / 2);
  }
`;

const ContentWrapper = styled.div`
  width: 400px;
  border-radius: 6px;
  margin: 20px 20px 20px 10px;

  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;

  overflow-y: scroll;
  &::-webkit-scrollbar {
    display: none;
  }
  -ms-overflow-style: none; /* Internet Explorer and Edge */
  scrollbar-width: none; /* Firefox */

  @media only screen and (max-width: 808px) {
    margin: 20px;
  }
`;

const Logo = styled.div`
  width: 60px;
  height: 60px;
  background-image: url("./favicon.png");
  background-size: cover;

  @media only screen and (max-width: 808px) {
    width: 30px;
    height: 30px;
  }
`;

const Title = styled.p`
  font-size: 24px;
  font-weight: 500;
  line-height: 30px;
`;

const StepperForm = styled(Steps)`
  box-shadow: 0px -2px 0 0 #d9d9d9 inset;
  .ant-steps-item-icon,
  .ant-steps-item::after {
    display: none;
  }

  @media only screen and (max-width: 652px) {
    width: 200px;
  }
`;

const FormItem = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;

  @media only screen and (max-width: 652px) {
    width: 300px;
  }

  @media only screen and (max-width: 448px) {
    width: 200px;
  }
`;

const ItemTitle = styled.p`
  width: 150px;
  font-size: 12px;
  font-weight: 400;
  line-height: 24px;
  color: #373b4099;
`;

const ItemInput = styled.input`
  width: 300px;
  height: 40px;
  border: 1px solid #00000029;
  font-size: 14px;
  font-weight: 400;
  line-height: 24px;
  color: #373b40;
  &:focus {
    outline: 1px solid #00000049;
    border-radius: 2px;
  }

  @media only screen and (max-width: 448px) {
    width: 200px;
  }
`;

const NextButton = styled.button`
  width: 170px;
  height: 40px;
  background-color: ${(props) =>
    props.disabled ? "rgb(180,180,180)" : "#4f82fc"};
  transition: all 0.8s ease;
  border-radius: 14px;
  color: #fff;
`;

const RegisterButton = styled.button`
  width: 170px;
  height: 40px;
  background-color: ${(props) =>
    props.disabled ? "rgb(180,180,180)" : "#4f82fc"};
  color: #fff;
  border-radius: 14px;
  transition: all 0.8s ease;

  @media only screen and (max-width: 652px) {
    width: 300px;
  }
`;
const PrevButton = styled.button`
  width: 170px;
  height: 40px;
  background-color: transparent;
  border-radius: 14px;
  color: #373b4099;
  font-size: 16px;

  &:hover {
    background-color: rgba(0, 0, 0, 0.05);
    color: #4f82fc;
    transition: all 0.5s ease;
  }

  @media only screen and (max-width: 652px) {
    width: 300px;
  }
`;

const NavigationButtons = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-around;
  margin-top: 40px;

  @media only screen and (max-width: 652px) {
    width: 100%;
  }
  @media only screen and (max-width: 652px) {
    width: 300px;
  }
`;

const NewRouteButton = styled.button`
  border-radius: 12px;
  background-color: #27aae1;
  width: fit-content;
  height: fit-content;
  padding: 10px 40px;
  color: #fff;
  font-weight: 500;
  font-size: 16px;
  line-height: 20px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  gap: 8px;
  transition: all 0.6s ease;

  &:hover {
    background-color: #4bc7fa;
    transition: all 0.6s ease;
  }
`;

const ModalContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 30px;
  padding-block: 30px;
  justify-content: center;
  align-items: center;
`;

const ErrorText = styled.span`
  width: 300px;
  color: red;
  font-weight: 600;
  font-size: 11px;
  line-height: 10px;
  margin-top: 6px;
  align-self: center;

  @media only screen and (max-width: 448px) {
    width: 200px;
  }
`;
